export const regex = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  emailDomain: /^([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/i,
  name: /^[가-힣]{2,4}|[a-zA-Z]{2,10}$/,
  password: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*\W).{8,}$/,
  birthdate: /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/,
  url: /^http(s)?:\/\/(localhost|(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6})\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/,
  tel: /^\d{2,3}\d{3,4}\d{4}$/,
  slug: /^[^/?]+$/,

} as const;

export const replace = {
  birthdate: (birth: string) => birth.replace(/^(\d{4})(\d+)(\d{2})$/, '$1-$2-$3'),
  phoneWithCountryCode: (phone: string) => phone.replace(/^0(\d+)/, '+82$1'),
  phoneWithoutCountryCode: (phone: string) => phone.replace(/^\+82([01]{2})([\d*]{3,4})(\d{4})$/, '0$1-$2-$3'),
  phoneWithoutCountryCodeNoDash: (phone: string) => phone.replace(/^\+82([01]{2})(\d{3,4})(\d{4})$/, '0$1$2$3'),
};
